import 'bootstrap/dist/css/bootstrap.min.css';
import { injectGlobal } from 'styled-components';

injectGlobal`


`;



// WEBPACK FOOTER //
// ./src/assets/styles/admin.js